import yup from "../../../../validation/yup";

export const validationSchema = yup.object().shape({
    inputText: yup
        .string()
        .required()
        .trim()
});